import { Technologies } from '@/components/sections/Technologies';
import { technologies } from '@/data/technologies';

export const TechnologiesPage = () => {
  return <Technologies technologies={technologies} />;
};
